import React, { ReactElement } from 'react';
import { Body, Headline, Text } from '../../../components';
import Block from '../../block';
import Meta from '../../meta';
import GlobalTemplate from '../global';
import SupportNav from './partials/support-nav';
import './style.css';

// The wrapper template for all pages on the /support route.
export default function SupportTemplate({ children }): ReactElement {
  return (
    <GlobalTemplate pageBgColor="white" navBgColor="purple-500">
      <Meta title="Support: How can our team help you?">
        <meta name="theme-color" content="#381FD1"></meta>
      </Meta>

      <Block
        className="bg-cover bg-bottom bg-no-repeat pt-16"
        style={{
          backgroundImage:
            "url('https://images.getstark.co/marketing/headers/gradient-bg.webp')",
          marginTop: -65,
        }}
        bgColor="var(--color-base-purple-500)">
        <header className="relative mt-14">
          <div className="relative z-10 max-w-[592px]">
            <Text level="mono" color="yellow" className="mb-4">
              Support
            </Text>

            <Headline level="hero" color="white">
              How can we help you?
            </Headline>

            <Body color="white" className="mb-24 mt-6 max-w-[532px]">
              Get answers to all your Stark-related questions with <br />
              step-by-step guides from our Support center.
            </Body>
          </div>
        </header>
      </Block>

      <Block>
        <div className="support-main__wrapper flex">
          <SupportNav />

          <main
            className="support-main mt-20 w-full scroll-mt-40 md:scroll-mt-20"
            id="main">
            {children}
          </main>
        </div>
      </Block>
    </GlobalTemplate>
  );
}
